import React from 'react';
import { motion } from 'framer-motion';

// Hand-drawn style SVG doodles for the landing page.

export function Squiggle({ className = '', width = 220 }) {
  return (
    <svg viewBox="0 0 220 14" width={width} className={className} fill="none" aria-hidden="true">
      <motion.path
        d="M3 9 Q 20 2, 38 8 T 73 8 T 108 8 T 143 8 T 178 8 T 215 7"
        stroke="currentColor" strokeWidth="5" strokeLinecap="round"
        initial={{ pathLength: 0 }} whileInView={{ pathLength: 1 }} viewport={{ once: true }}
        transition={{ duration: 0.9, ease: 'easeOut', delay: 0.3 }}
      />
    </svg>
  );
}

export function Sparkle({ className = '', size = 26, delay = 0 }) {
  return (
    <motion.svg viewBox="0 0 24 24" width={size} height={size} className={className} fill="currentColor" aria-hidden="true"
      animate={{ scale: [1, 1.25, 1], rotate: [0, 12, 0], opacity: [0.7, 1, 0.7] }}
      transition={{ duration: 2.6, repeat: Infinity, ease: 'easeInOut', delay }}>
      <path d="M12 1.5c.6 4.8 2.7 6.9 7.5 7.5-4.8.6-6.9 2.7-7.5 7.5-.6-4.8-2.7-6.9-7.5-7.5 4.8-.6 6.9-2.7 7.5-7.5z" />
    </motion.svg>
  );
}

export function ScribbleArrow({ className = '', width = 90, flip = false }) {
  return (
    <svg viewBox="0 0 90 60" width={width} className={className} fill="none" aria-hidden="true"
      style={flip ? { transform: 'scaleX(-1)' } : undefined}>
      <motion.path
        d="M6 8 C 18 38, 44 52, 76 44 M 76 44 l -12 -7 M 76 44 l -4 12"
        stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"
        initial={{ pathLength: 0 }} whileInView={{ pathLength: 1 }} viewport={{ once: true }}
        transition={{ duration: 0.8, ease: 'easeOut', delay: 0.4 }}
      />
    </svg>
  );
}

export function DottedPath({ className = '' }) {
  return (
    <svg viewBox="0 0 600 40" className={className} fill="none" preserveAspectRatio="none" aria-hidden="true">
      <path d="M10 30 Q 150 -10, 300 22 T 590 14" stroke="currentColor" strokeWidth="3"
        strokeLinecap="round" strokeDasharray="1 12" />
    </svg>
  );
}

export function Blob({ className = '', color = '#FFD8C9' }) {
  return (
    <svg viewBox="0 0 200 200" className={className} aria-hidden="true">
      <path fill={color}
        d="M45.7,-58.8C58.9,-49.4,69.1,-35.3,73.4,-19.4C77.7,-3.4,76.2,14.4,68.4,28.4C60.6,42.4,46.6,52.6,31.5,59.4C16.4,66.2,0.2,69.6,-16.9,67.5C-34,65.4,-52,57.8,-62.6,44.3C-73.2,30.8,-76.4,11.4,-73.3,-6.3C-70.2,-24,-60.8,-40,-47.7,-49.5C-34.6,-59,-17.3,-62,-0.3,-61.6C16.7,-61.3,32.5,-68.2,45.7,-58.8Z"
        transform="translate(100 100)" />
    </svg>
  );
}
